import { render, staticRenderFns } from "./SocialMediaForm.vue?vue&type=template&id=2ba8e61a&scoped=true&"
import script from "./SocialMediaForm.vue?vue&type=script&lang=js&"
export * from "./SocialMediaForm.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaForm.vue?vue&type=style&index=0&id=2ba8e61a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba8e61a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow,VSpacer})
